<template>
  <b-row>
    <b-col class="col-lg-6 offset-lg-3 col-sm-12">
      <div>
        <p>Your Delete Request has been sent. Please give us 45 days for your request to be completed.</p>
      </div>
    </b-col>
  </b-row>
</template>
<script>
import { mapState } from 'vuex'

export default {
  created: function () {
    this.logOutMethod()
  },
  computed: mapState([
    'logOutRedirect'
  ]),
  methods: {
    logOutMethod () {
      setTimeout(function () { this.$store.dispatch('logOutRedirect') }.bind(this), 5000)
    }
  }
}
</script>
